const paramServiceConfig = {
    getAllParamByFeature: '/get-all-user-params',
    addParams: '/add-params',
    getAllUserParams: '/get-user-params'
};

export default paramServiceConfig;
